import React from 'react';
import { FaCheckCircle, FaInfoCircle } from 'react-icons/fa';
import { getCalidadDisplay, formatFinanzasActualizado } from '../../../utils/finanzasUi';

/**
 * Sello de confianza bajo ganancias — solo presentación (FINANZAS-CORE-05).
 * POS-UX-CONTROL-RECOVERY-001: sin datos suficientes → neutro, no "validado/perfecto".
 */
export default function FinanzasSelloConfianza({
  cobertura,
  calidadFinanciera,
  actualizadoEn,
  compact = false
}) {
  if (!cobertura || !calidadFinanciera) return null;

  const ventasTotal = Number(cobertura.ventas_total) || 0;
  const evaluable = calidadFinanciera.evaluable !== false
    && calidadFinanciera.score != null
    && ventasTotal > 0;

  const pctReal = cobertura.pct_real ?? 0;
  const { label, badgeClass } = getCalidadDisplay(
    evaluable ? calidadFinanciera.score : null,
    { evaluable }
  );
  const fechaLabel = formatFinanzasActualizado(actualizadoEn);
  const textSize = compact ? 'text-[11px]' : 'text-xs';

  if (!evaluable) {
    return (
      <div
        className={`mt-3 rounded-lg border border-slate-500/30 bg-slate-500/10 ${compact ? 'px-2.5 py-2' : 'px-3 py-2.5'}`}
        aria-label="Salud financiera no evaluable"
      >
        <p className={`${textSize} font-semibold text-slate-200 flex items-center gap-1.5`}>
          <FaInfoCircle className="shrink-0 text-slate-300" aria-hidden />
          Salud financiera aún no evaluable
        </p>
        <p className={`${textSize} text-e0e3-muted mt-1.5`}>
          Cobertura real:{' '}
          <span className="font-semibold text-slate-300">
            {ventasTotal === 0 ? 'sin ventas en el período' : `${pctReal} %`}
          </span>
        </p>
        <p className={`${textSize} text-e0e3-muted mt-1`}>
          {calidadFinanciera.motivoNoEvaluable
            || 'Registrá ventas con costo para obtener una evaluación real.'}
        </p>
        <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
          <span
            className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${badgeClass}`}
          >
            {label}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`mt-3 rounded-lg border border-emerald-500/25 bg-emerald-500/10 ${compact ? 'px-2.5 py-2' : 'px-3 py-2.5'}`}
      aria-label="Sello de confianza financiera"
    >
      <p className={`${textSize} font-semibold text-emerald-200 flex items-center gap-1.5`}>
        <FaCheckCircle className="shrink-0 text-emerald-400" aria-hidden />
        Información validada
      </p>
      <p className={`${textSize} text-e0e3-muted mt-1.5`}>
        Cobertura real:{' '}
        <span className="font-semibold text-emerald-300">{pctReal} %</span>
      </p>
      <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
        <span className={`${textSize} text-e0e3-muted`}>Precisión:</span>
        <span
          className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${badgeClass}`}
        >
          {label}
        </span>
      </div>
      {fechaLabel && (
        <p className={`${compact ? 'text-[10px]' : 'text-[11px]'} text-e0e3-muted/80 mt-2`}>
          Última actualización: {fechaLabel}
        </p>
      )}
    </div>
  );
}
